// src/services/dataService.js
import axios from 'axios';
import setUpAxios  from '../setUpAxios';  // Ensure the setUpAxios is imported for setting headers/axios config
import { baseURL } from '../config'; // Assume the baseURL is stored in the config
import api from './api';
/**
 * Service function to fetch data from backend based on userId or props.
 * @param {string} startDate - The start date of the period
 * @param {string} endDate - The end date of the period
 * @param {string} userId - The user ID (optional)
 * @param {string} propsUserId - The user ID from props (optional)
 * @returns {Promise<object>} The fetched data containing entries and totals
 */
export const fetchEntries = async (startDate, endDate, userId=null,propsUserId=null) => {
  try {
    setUpAxios(); // Set up any global Axios config
    
    let endpoint = `${baseURL}/showEntries`;

    // Check if userId or propsUserId are provided, adjust endpoint accordingly
    if (userId) {
      endpoint = `${baseURL}/admin/showEntries`;
    } else if (propsUserId) {
      endpoint = `${baseURL}/admin/showEntries`;
    }
    
    // Make the request with the necessary data
    const response = await axios.post(endpoint, { startDate, endDate, userId: userId || propsUserId });
    
    if (!response.data) {
      throw new Error('No data received');
    }

    // Return the data object
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error('There was a problem with the fetch operation:', error);
    throw error;  // Propagate error to be handled in the calling component
  }
};

export const fetchBalance = async (startDate, endDate, userId=null) => {
  try {
    setUpAxios(); // Set up any global Axios config
    let response;
    if (userId) {
      // If userId is present, send userId with the request to '/admin/showBalance'
      response = await axios.post(`${baseURL}/admin/showBalance`, { startDate, endDate, userId });
    } else {
      // Otherwise, send request to '/showBalance' (default endpoint)
      response = await axios.post(`${baseURL}/showBalance`, { startDate, endDate });
    }
    
console.log(response.data);
    return response.data;
  } catch (error) {
    console.error('There was a problem with the fetch operation:', error);
    throw error;  // Propagate error to be handled in the calling component
  }
};

export const fetchBalanceEntries = async (startDate, endDate, userId=null) => {
  try {
    setUpAxios(); // Set up any global Axios config
    let response;
    if (userId) {
        // If userId is present, send userId with the request to '/admin/balanceSheet'
        response = await axios.post(`${baseURL}/admin/balanceSheet`, { startDate, endDate, userId });
    } else {
        // Otherwise, send request to '/balanceSheet' (default endpoint)
        response = await axios.post(`${baseURL}/balanceSheet`, { startDate, endDate });
    }

    return response.data;
  } catch (error) {
    console.error('There was a problem with the fetch operation:', error);
    throw error;  // Propagate error to be handled in the calling component
  }
};

export const fetchUserProfile = async () => {
  try {
    setUpAxios();
    const response = await api.get(`/user-profile`);
    return response.data.userProfile;
  } catch (error) {
    console.error("Error fetching user profile:", error);
    throw error; // Optionally rethrow the error for further handling
  }
};